<template>

<v-dialog v-model="notificationBar.show" id="logout-warning" persistent max-width="400px">

  <v-card>

    <!-- Modal Contents -->
    <v-card-text class="pa-5 text-center">

    	<div class="text-center mb-4">
				<v-icon large color="error">mdi-alert-circle-outline</v-icon>
			</div>

    	<div class="mb-2">
    		{{ $t('compLogInWatcher.logOutWarning.intro', {time: logoutTimeLeftDisplay}) }}
    	</div>

      <div class="text-center my-3">

        <v-btn
					color="success"
					:disabled="loginExtendRequestLoading"
					@click="extendLogInSession"
					class="mb-2"
				>
					{{ $t('compLogInWatcher.logOutWarning.btnKeepLoggedIn') }}
					<ButtonLoading v-show="loginExtendRequestLoading" class="ml-3" />
				</v-btn>

      </div>

    </v-card-text>

  </v-card>
</v-dialog>



</template>

<script>
import { config } from '@/config'
import jwtDecode from 'jwt-decode'
import ButtonLoading from "@/components/ButtonLoading"
export default {
	name: 'LoginWatcher',
	components: {
		ButtonLoading
	},
	props: {
		logoutRedirect: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			loading: false,
			loopJob: null,
			logoutTimeLeft: null,
			loginExtendRequestLoading: false,
			notificationBar: {
				show: false,
				type: 'error', // 'success', 'error'
				message: ''
			}
		}
	},
	computed: {
		logoutTimeLeftDisplay: function () {
			if (this.logoutTimeLeft) {
				return parseInt(this.logoutTimeLeft)
			}
			else {
				return null
			}
		},
	},
	methods: {
		async init() {
			// console.log('LoginWatcher init')
			if (this.$router.currentRoute.name == this.logoutRedirect) {
				console.log('already on the logout page.')
				return
			}
			await this.check()
			this.loopJob = setInterval(this.check, 5000)
		},

		closeNotification() {
			if (this.loopJob) {
				clearInterval(this.loopJob)
			}
			this.notificationBar.show = false
		},

		async check () {
			// console.log('LoginWatcher checking...')

			if (this.loading === true) {
				return
			}

			this.loading = true

			const jwtToken = localStorage.getItem(config.localStorageKey.login)

			if (!jwtToken) {
				// console.log('jtwToken Changed')
				// this.previousJwtToken = jwtToken
				this.loading = false
				this.closeNotification()
				this.redirectToPage(this.logoutRedirect)
				return
			}

			const jwtTokenInfo = jwtDecode(jwtToken)
			const jwtTokenTrackKey = jwtTokenInfo.networkId + '-' + jwtTokenInfo.userAddress

			//------------------------------------------------------
			// Check if wallet is connected
			//------------------------------------------------------
			if (!window.ethereum || !window.ethereum.selectedAddress || !window.ethereum.networkVersion) {
				console.log('wallet not collected.')
				this.loading = false
				this.closeNotification()
				this.redirectToPage(this.logoutRedirect)
				return
			}

			const myAddress = window.ethereum.selectedAddress.toLowerCase()
			const networkId = window.ethereum.networkVersion

			//------------------------------------------------------
			// Check if wallet info matches token info
			//------------------------------------------------------
			// console.log(myAddress.toLowerCase())
			// console.log(jwtTokenInfo.userAddress.toLowerCase())
			// console.log(networkId)
			// console.log(jwtTokenInfo.networkId)
			if (myAddress.toLowerCase() !== jwtTokenInfo.userAddress.toLowerCase() || parseInt(networkId) !== parseInt(jwtTokenInfo.networkId)) {
				console.log('wallet and token does not match.')
				this.loading = false
				this.closeNotification()
				this.redirectToPage(this.logoutRedirect)
				return
			}

			const now = (new Date()).getTime()
			this.logoutTimeLeft = (jwtTokenInfo.exp - now / 1000) / 60  // in minutes
			// console.log('time left: ' + this.logoutTimeLeft)

			//------------------------------------------------------
			// Check if jwt towken has expired
			//------------------------------------------------------
			if (this.logoutTimeLeft && this.logoutTimeLeft <= 0) {
				console.log('jwtToken Expired')
				this.loading = false
				this.closeNotification()
				this.redirectToPage(this.logoutRedirect)
				return
			}

			//------------------------------------------------------
			// Check if need to show logout alert
			//------------------------------------------------------
			if (this.logoutTimeLeft && this.logoutTimeLeft < config.logOutWarningTime) {
				this.notificationBar.show = true
			}

			this.loading = false

		},

		redirectToPage (routeName) {
			// console.log(this.$router.currentRoute)
			console.log('loginWatcher redirecting from ' + this.$router.currentRoute.name + ' to ' + routeName)
			if (this.$router.currentRoute.name.toLowerCase() !== routeName.toLowerCase()) {
				this.$router.push({name: routeName})
			}
		},

		extendLogInSession () {
			this.loginExtendRequestLoading = true
			const url = config.backendLogInExtendURL
			const that = this
			this.$http.post(url).then(
				(res) => {
					// console.log(res)
					const jwtToken = res.body.token
					// console.log(jwtToken)
					localStorage.setItem(config.localStorageKey.login, jwtToken)
					that.loginExtendRequestLoading = false
					that.notificationBar.show = false
				},
				(err) => {
					that.loginExtendRequestLoading = false
					that.notificationBar.show = false
					console.log(err)
				}
			)
		}

	},
	created () {
		this.init()
	},
	beforeDestroy () {
		this.closeNotification()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
